export default "__VITE_ASSET__8f998215__"